import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const AuthLayout = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      height="100vh"
      width={'100%'}
      maxWidth={'800px'}
      bgcolor="background.paper"
      justifyContent={'space-between'}
      sx={{
        mx: 'auto',
        boxShadow: { xs: 'none', sm: '0px 0px 40px 0px rgba(17,17,17,0.08)' },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        width={'100%'}
        height="100vh"
        sx={{
          overflowY: 'scroll',
          overflowX: 'hidden',
        }}
      >
        {children}
        <Stack
          style={{ marginBottom: '24px' }}
          justifyContent={'flex-end'}
          alignItems={'center'}
          height={'100%'}
          width={'100%'}
          marginTop={'16px'}
        >
          <Typography
            color={'primary.gray'}
            fontSize={16}
            fontWeight={600}
            textAlign={'left'}
          >
            تماس با پشتیبانی
          </Typography>
          <a href="tel:02191300250" style={{ textDecoration: 'none' }}>
            <Typography
              paddingRight={'5px'}
              paddingLeft={'5px'}
              color={'primary.gray'}
              fontSize={16}
              fontWeight={600}
              textAlign={'left'}
            >
              021-91300250
            </Typography>
          </a>
          {/* <Typography
            marginTop={"12px"}
            color={"primary.gray"}
            fontSize={16}
            fontWeight={600}
            textAlign={"center"}
            width={"100%"}
          >
            نسخه {process.env.REACT_APP_VERSION}
          </Typography> */}
        </Stack>
      </Box>
    </Box>
  );
};

export default AuthLayout;
